import { Fragment, useMemo } from "react";
import ActivityInventoryModal from "./Activitybulkmodals/ActivityInventoryModal";
import ActivityRatesModal from "./Activitybulkmodals/ActivityRatesModal";
import ActivityBlackoutModal from "./Activitybulkmodals/ActivityBlackoutModal";
import { Modal } from "react-bootstrap";

export default function ActivityBulkUpdateModal(props) {
    const {
        open,
        title,
        isEdit,
        selectedCellDate,
        availabilityDates,
        setOpenModal,
        ActivityBasicInfoId,
        UserId,
        ActivityName,
        dropDownList,
        dropdownData

    } = props;

    const RenderModal = useMemo(() => {
        switch (title?.name) {
            case 'Inventory':
                return <ActivityInventoryModal
                    title={title?.alias}
                    isEdit={isEdit}
                    selectedCellDate={selectedCellDate}
                    availabilityDates={availabilityDates}
                    setOpenModal={setOpenModal}
                    ActivityBasicInfoId={ActivityBasicInfoId}
                    UserId={UserId}
                    ActivityName={ActivityName}
                />;
            case 'Rates':
                return <ActivityRatesModal
                    title={title?.alias}
                    isEdit={isEdit}
                    selectedCellDate={selectedCellDate}
                    availabilityDates={availabilityDates}
                    setOpenModal={setOpenModal}
                    ActivityBasicInfoId={ActivityBasicInfoId}
                    UserId={UserId}
                    ActivityName={ActivityName}
                    dropDownList={dropDownList}
                    dropdownData={dropdownData}
                />;
            case 'Blackout':
                return <ActivityBlackoutModal
                    title={title?.alias}
                    isEdit={isEdit}
                    selectedCellDate={selectedCellDate}
                    availabilityDates={availabilityDates}
                    setOpenModal={setOpenModal}
                    ActivityBasicInfoId={ActivityBasicInfoId}
                    UserId={UserId}
                    ActivityName={ActivityName}
                />;
            default: return ''
        }
    }, [title, isEdit, selectedCellDate, availabilityDates])

    return (
        <Fragment>
            <Modal
                show={open}
                onHide={() => setOpenModal(false)}
                size="lg"
                backdrop="static"
                aria-labelledby="contained-modal-title-vcenter"
                dialogClassName="sign-in-class"
                centered
            >
                <div className="p-4">
                    {RenderModal}
                </div>
            </Modal>
        </Fragment>
    );
}